module.exports = __webpack_public_path__ + "assets/img/1-2.7b26f91c.png";